import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import CopyToClipboard from 'react-copy-to-clipboard';
import { Screen } from '~/views'
import { NotifyActions, BlueprintImporter } from '~/actions'

class RawBlueprintsScreen extends React.Component {

  static contextTypes = { 
    api : PropTypes.object.isRequired
  }

  constructor( props ) {
    super( props );
    this.state = { error : false, blueprint : null, data : null }
  }

  async componentDidMount() {
    const { api } = this.context
    const { match : { params } } = this.props

    this.mounted = true
    if ( params && params.projectId && params.blueprintId ) {
      let blueprint, blueprints
      try {
        blueprint = await api.getBlueprint( params.projectId, params.blueprintId )
        blueprints = await api.project( params.projectId ).blueprints().list( { perPage : 1000 } )
      } catch ( ex ) {
        if ( this.mounted ) {
          this.setState( { error : true } )
        }
      }
      
      const json = BlueprintImporter.blueprintToJsonStr( blueprint, blueprints.items )
      if ( this.mounted ) {
        this.setState( { blueprint : json, data : blueprint } )
      }
    }
  }
  
  componentWillUnmount() {
    this.mounted = false
  }
  
  // from npm downloadbutton    
  onDownload( fileData ) {
    const blob = new Blob( [ fileData.contents ], { type : fileData.mime } )
    const url = URL.createObjectURL( blob )
    saveAs( url, fileData.filename )

  }

  copied = () => {
    this.props.dispatch( NotifyActions.success( 'Copy', 'Blueprint has been copied to your clipboard' ) )
  }
  
  render() {
    const { error, blueprint, data } = this.state
    if ( error ) {
      return <div>Error loading blueprint...</div>;
    } 
    if ( blueprint == null ) {
      return <div>Loading blueprint...</div>;
    }
    const fileData = {
      filename : `${data.name}.json`,
      mime : 'text/plain',
      contents : blueprint
    }

    return (
      <Screen>
        <Screen.Header>
          <Button onClick={() => { this.onDownload( fileData ) }}>
            <i className="fa fa-download fa-fw" />
            {' '}
            Download
          </Button>
          &nbsp;
          <CopyToClipboard text={blueprint} onCopy={this.copied}>
            <Button> 
              {' '}
              <i className="fa fa-copy fa-fw" />
              {' '}
              Copy to Clipboard
              {' '}
            </Button>
          </CopyToClipboard>

        </Screen.Header>
        <Screen.Content>
          <pre style={{ background : 'white', overflow : 'auto', height : '100%', width : '100%', margin : 0 }}>
            {blueprint}
          </pre>
        </Screen.Content>
      </Screen>
    )
  }

} 

// from npm downloadbutton
// from http://stackoverflow.com/questions/283956/
function saveAs( uri, filename ) {
  const link = document.createElement( 'a' );
  if ( typeof link.download === 'string' ) {
    document.body.appendChild( link ); // Firefox requires the link to be in the body
    link.download = filename;
    link.href = uri;
    link.click();
    document.body.removeChild( link ); // remove the link when done
  } else {
    location.replace( uri );
  }
}

export default connect( state => ( { } ) )( RawBlueprintsScreen )
